module.exports = __webpack_public_path__ + "static/media/passo31.8d47ec1c.jpg";